import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuthStore, useRealtimeChannel } from '@readsavor/auth';
export const CreditProvider = ({ children }) => {
    const queryClient = useQueryClient();
    const { session, status } = useAuthStore();
    const userId = session?.user?.id;
    const channelName = userId ? `user-credit-updates-for-${userId}` : null;
    const userChannel = useRealtimeChannel(channelName);
    // 效果一：响应认证状态的变化 (保持不变)
    useEffect(() => {
        if (status === 'pending')
            return;
        if (!session) {
            queryClient.removeQueries({ queryKey: ['credits'] });
        }
        else {
            queryClient.invalidateQueries({ queryKey: ['credits'] });
        }
    }, [session, status, queryClient]);
    // 效果二：当获得稳定可用的 channel 后，附加业务逻辑监听器
    useEffect(() => {
        if (!userChannel || !userId) {
            return;
        }
        const handleInvalidate = (payload) => {
            queryClient.invalidateQueries({ queryKey: ['credits'] });
        };
        const listenerA = userChannel.on('postgres_changes', {
            event: 'INSERT',
            schema: 'public',
            table: 'user_subscription_cycles',
            filter: `user_id=eq.${userId}`,
        }, handleInvalidate);
        const listenerB = userChannel.on('postgres_changes', {
            event: '*',
            schema: 'public',
            table: 'user_core_credits',
            filter: `user_id=eq.${userId}`,
        }, handleInvalidate);
        const listenerC = userChannel.on('postgres_changes', {
            event: '*',
            schema: 'public',
            table: 'user_welfare_credits',
            filter: `user_id=eq.${userId}`,
        }, handleInvalidate);
        // useRealtimeChannel 已经处理了 subscribe 和 unsubscribe
        // 我们只需要在组件卸载或 channel 变化时，清理这些事件监听器
        return () => {
            listenerA.unsubscribe();
            listenerB.unsubscribe();
            listenerC.unsubscribe();
        };
    }, [userChannel, userId, queryClient]);
    return _jsx(_Fragment, { children: children });
};
//# sourceMappingURL=CreditProvider.js.map